import { identityHashCodemue8eqr5m304 as identityHashCode } from '../../../../../kiteui-library/com/lightningkite/kiteui/debugger.js.mjs';
import { delay2kng7ucb3aj62 as delay } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Delay.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  toList3jhuyej2anx2q as toList,
  zipfdxxupzuj2p9 as zip,
  joinToString1cxrrlmo0chqs as joinToString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  $3l5vvh8yg0ier as $,
  orPromise1iucc2to2udt2 as orPromise,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { printStackTrace18lnx7a39cni as printStackTrace } from '../../../../../kotlin-kotlin-stdlib/kotlin/throwableExtensions.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  Companion_getInstance2jahap30xtp3t as Companion_getInstance,
  toDuration28gf6ughsr3vf as toDuration,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationUnit_SECONDS_getInstance162tnxlnf2fpv as DurationUnit_SECONDS_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { HashMap1a0ld5kgwhmhv as HashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/HashMap.mjs';
import { CompletableDeferred2lnqvsbvx74d3 as CompletableDeferred } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CompletableDeferred.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { arrayListOf1fz8nib0ncbow as arrayListOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { HashSet2dzve9y63nf0v as HashSet } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/HashSet.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function BatchAndQueue$invoke$slambda$lambda(it) {
  return identityHashCode(it).toString();
}
function BatchAndQueue$invoke$slambda$lambda_0(it) {
  return identityHashCode(it).toString();
}
function BatchAndQueue$invoke$slambda($$this$run, $queue) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    yield* delay($$this$run.batchWait_1, $completion);
    var tmp0_safe_receiver = $$this$run.log_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.log_iyb52q_k$(['Starting request']);
    }
    var tmp;
    if ($$this$run.multigetQueue_1 === $queue) {
      $$this$run.multigetQueue_1 = null;
      tmp = Unit_instance;
    }
    var tmp_0;
    try {
      var allInputs = toList($queue);
      var allOutputs = zip(allInputs, yield* $($$this$run.fulfill_1(allInputs, $completion), $completion));
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s = allOutputs.iterator_jk1svi_k$();
      while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
        var element = _iterator__ex2g4s.next_20eer_k$();
        var key = element.component1_7eebsc_k$();
        var value = element.component2_7eebsb_k$();
        var out = $$this$run.outgoing_1.remove_gppy8k_k$(key);
        var tmp0_safe_receiver_0 = $$this$run.log_1;
        if (tmp0_safe_receiver_0 == null)
          null;
        else {
          var tmp_1;
          if (out == null) {
            tmp_1 = null;
          } else {
            tmp_1 = joinToString(out, VOID, VOID, VOID, VOID, VOID, BatchAndQueue$invoke$slambda$lambda);
          }
          tmp0_safe_receiver_0.log_iyb52q_k$(['Finished request. Sending results to ' + tmp_1]);
        }
        if (out == null)
          null;
        else {
          // Inline function 'kotlin.collections.forEach' call
          var _iterator__ex2g4s_0 = out.iterator_jk1svi_k$();
          while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
            var element_0 = _iterator__ex2g4s_0.next_20eer_k$();
            element_0.complete_ixf84q_k$(value);
          }
        }
      }
      tmp_0 = Unit_instance;
    } catch ($p) {
      var tmp_2;
      if ($p instanceof Exception()) {
        var e = $p;
        printStackTrace(e);
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s_1 = $queue.iterator_jk1svi_k$();
        while (_iterator__ex2g4s_1.hasNext_bitz1p_k$()) {
          var element_1 = _iterator__ex2g4s_1.next_20eer_k$();
          var out_0 = $$this$run.outgoing_1.remove_gppy8k_k$(element_1);
          var tmp0_safe_receiver_1 = $$this$run.log_1;
          if (tmp0_safe_receiver_1 == null)
            null;
          else {
            var tmp_3 = e.toString();
            var tmp_4;
            if (out_0 == null) {
              tmp_4 = null;
            } else {
              tmp_4 = joinToString(out_0, VOID, VOID, VOID, VOID, VOID, BatchAndQueue$invoke$slambda$lambda_0);
            }
            tmp0_safe_receiver_1.log_iyb52q_k$(['Failed to send request. Sending ' + tmp_3 + ' to ' + tmp_4]);
          }
          if (out_0 == null)
            null;
          else {
            // Inline function 'kotlin.collections.forEach' call
            var _iterator__ex2g4s_2 = out_0.iterator_jk1svi_k$();
            while (_iterator__ex2g4s_2.hasNext_bitz1p_k$()) {
              var element_2 = _iterator__ex2g4s_2.next_20eer_k$();
              element_2.completeExceptionally_xyzekf_k$(e);
            }
          }
        }
        tmp_2 = Unit_instance;
      } else {
        throw $p;
      }
      tmp_0 = tmp_2;
    }
    return Unit_instance;
  }), 1);
}
var BatchAndQueueClass;
function BatchAndQueue() {
  if (BatchAndQueueClass === VOID) {
    class $ {
      constructor(scope, batchWait, log, fulfill) {
        var tmp;
        if (batchWait === VOID) {
          // Inline function 'kotlin.time.Companion.seconds' call
          Companion_getInstance();
          tmp = toDuration(0.1, DurationUnit_SECONDS_getInstance());
        } else {
          tmp = batchWait;
        }
        batchWait = tmp;
        log = log === VOID ? null : log;
        this.scope_1 = scope;
        this.batchWait_1 = batchWait;
        this.log_1 = log;
        this.fulfill_1 = fulfill;
        this.outgoing_1 = HashMap().new_kotlin_collections_HashMap_2a5kxx_k$();
        this.multigetQueue_1 = null;
      }
      *invoke_nzm626_k$(input, $completion) {
        var deferred = CompletableDeferred();
        var tmp0_safe_receiver = this.log_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.log_iyb52q_k$([toString(input) + ' starting with deferred ' + identityHashCode(deferred)]);
        }
        var tmp1_safe_receiver = this.outgoing_1.get_wei43m_k$(input);
        var tmp;
        if (tmp1_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          var tmp0_safe_receiver_0 = this.log_1;
          if (tmp0_safe_receiver_0 == null)
            null;
          else {
            tmp0_safe_receiver_0.log_iyb52q_k$([toString(input) + ' already in progress']);
          }
          tmp1_safe_receiver.add_utx5q5_k$(deferred);
          return yield* deferred.await_4rdzbx_k$($completion);
        }
        if (tmp == null) {
          // Inline function 'kotlin.run' call
          var tmp0 = this.outgoing_1;
          // Inline function 'kotlin.collections.set' call
          var value = arrayListOf([deferred]);
          tmp0.put_4fpzoq_k$(input, value);
        }
        var tmp3_safe_receiver = this.multigetQueue_1;
        var tmp_0;
        if (tmp3_safe_receiver == null) {
          tmp_0 = null;
        } else {
          // Inline function 'kotlin.takeUnless' call
          var tmp_1;
          if (!(tmp3_safe_receiver.get_size_woubt6_k$() > 500)) {
            tmp_1 = tmp3_safe_receiver;
          } else {
            tmp_1 = null;
          }
          tmp_0 = tmp_1;
        }
        var tmp4_safe_receiver = tmp_0;
        var tmp_2;
        if (tmp4_safe_receiver == null) {
          tmp_2 = null;
        } else {
          // Inline function 'kotlin.let' call
          var tmp0_safe_receiver_1 = this.log_1;
          if (tmp0_safe_receiver_1 == null)
            null;
          else {
            tmp0_safe_receiver_1.log_iyb52q_k$(['Adding ' + toString(input) + ' to existing queue']);
          }
          tmp_2 = tmp4_safe_receiver.add_utx5q5_k$(input);
        }
        if (tmp_2 == null) {
          // Inline function 'kotlin.run' call
          var tmp0_safe_receiver_2 = this.log_1;
          if (tmp0_safe_receiver_2 == null)
            null;
          else {
            tmp0_safe_receiver_2.log_iyb52q_k$(['Starting new queue for ' + toString(input)]);
          }
          var queue = HashSet().new_kotlin_collections_HashSet_ovxcsm_k$();
          queue.add_utx5q5_k$(input);
          this.multigetQueue_1 = queue;
          launch(this.scope_1, VOID, VOID, BatchAndQueue$invoke$slambda(this, queue));
        }
        try {
          return yield* deferred.await_4rdzbx_k$($completion);
        } catch ($p) {
          if ($p instanceof CancellationException()) {
            var e = $p;
            throw e;
          } else {
            if ($p instanceof Error) {
              var t = $p;
              var tmp6_safe_receiver = this.log_1;
              if (tmp6_safe_receiver == null)
                null;
              else {
                tmp6_safe_receiver.log_iyb52q_k$(['Failed to report. Error: ' + t.message]);
              }
              throw t;
            } else {
              throw $p;
            }
          }
        }
      }
    }
    initMetadataForClass($, 'BatchAndQueue', VOID, VOID, VOID, [1]);
    BatchAndQueueClass = $;
  }
  return BatchAndQueueClass;
}
//region block: exports
export {
  BatchAndQueue as BatchAndQueue1zjqkogt1zg44,
};
//endregion

//# sourceMappingURL=BatchAndQueue.mjs.map
